// extracted by mini-css-extract-plugin
module.exports = {"main":"style_main__YAlx8","heading":"style_heading__OWdSm"};